import { SERIALCOURSE_FETCH_END, SERIAL_FETCH_END } from '../constants'

export default function runtime(state = {
  courses: [],
  serialInfo: {},
  hasMore: false,
  serial: [], // 通过 courseIds 检索出的系列课
}, action) {
  switch (action.type) {
    case SERIALCOURSE_FETCH_END:
      return {
        ...state,
        courses: action.rank !== 0 ? state.courses.concat(action.data.course)
                : action.data.course,
        serialInfo: action.data.serial || {},
        hasMore: action.data.course && action.data.course.length >= 10,
      };
    case SERIAL_FETCH_END:
      return Object.assign({}, state, {
        serial: action.data,
      })
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/serial.js